import { type AxiosInstance } from 'axios';
import React, { useMemo } from 'react';
import { type IAsyncService } from './IAsyncService.ts';

export interface IAsyncServicesEngineContext {
  services: IAsyncService[];
  axiosClient?: AxiosInstance;
}

export const AsyncServicesEngineContext =
  React.createContext<IAsyncServicesEngineContext | null>(null);

export interface IAsyncServicesEngineContextProviderProps {
  services: IAsyncService[];
  axiosClient?: AxiosInstance;
  children: React.ReactNode;
}

/**
 * Definisce un contesto per ottenere l'elenco ai Servizi Esterni che
 * possono essere utilizzati nelle espressioni.
 */
export function AsyncServicesEngineContextProvider(
  props: IAsyncServicesEngineContextProviderProps,
) {
  const { services, axiosClient, children } = props;

  const value = useMemo(() => {
    return {
      services,
      axiosClient,
    };
  }, [axiosClient, services]);

  return (
    <AsyncServicesEngineContext.Provider value={value}>
      {children}
    </AsyncServicesEngineContext.Provider>
  );
}

export const useAsyncServiceEngineContext = () => {
  const context = React.useContext(AsyncServicesEngineContext);
  if (!context) {
    throw new Error(
      'useAsyncServiceEngineContext deve essere usato in un AsyncServicesEngineContextProvider',
    );
  }
  return context;
};
